export default class Gallery extends React.Component {
  constructor(props) {
    super(props);
    this.nextPic = this.nextPic.bind(this);
    this.prevPic = this.prevPic.bind(this);
    this.renderArrows = this.renderArrows.bind(this);
    this.countIndex = this.countIndex.bind(this);
    this.renderPreloader = this.renderPreloader.bind(this);
    this.state = {
      index: 0
    }
    this.mounted = false;
  }

  componentDidMount() {
    if (this.props.rotateImages) {
      setInterval(this.nextPic, 3000);
    }
    this.mounted = true;
  }

  shouldComponentUpdate(nextProps, nextState) {
    const isNotSamePicsLength = this.props.pics.length !== nextProps.pics.length;
    const isNotSameFirstPic = this.props.pics[0]?.normal_photo !== nextProps.pics[0]?.normal_photo;
    const isNotSameIndex = this.state.index !== nextState.index;

    return isNotSamePicsLength || isNotSameFirstPic || isNotSameIndex;
  }

  nextPic() {
    if (this.props.pics.length !== 0 && this.mounted) {
      this.setState({ index: this.countIndex(this.state.index + 1) });
    }
  }

  prevPic() {
    if (this.props.pics.length !== 0 && this.mounted) {
      this.setState({ index: this.countIndex(this.state.index - 1) });
    }
  }

  renderArrows() {
    if (this.props.pics.length > 1) {
      return (
        <div className='card__thumb-arrows'>
          <div className='card__thumb-arrow card__thumb-arrow-full-side card__thumb-arrow-full-side-prev'
               onClick={this.prevPic}
          >
            <div className='icon icon-arrow-white-light icon-arrow-white-light-dims'></div>
          </div>
          <div className='card__thumb-arrow card__thumb-arrow-full-side card__thumb-arrow-full-side-next'
               onClick={this.nextPic}
          >
            <div className='rotate icon icon-arrow-white-light icon-arrow-white-light-dims'></div>
          </div>
        </div>
      );
    }
  }

  // Возвращает индекс для замкнутого массива
  // Конец и начало замкнутого массива соединены
  countIndex(new_index) {
    const last_index = this.props.pics.length - 1;

    if (new_index < 0) {
      return last_index;
    } else if (new_index > last_index) {
      return 0;
    }
    return new_index;
  }

  renderPreloader() {
    return <div className='card-preload__thumb preload__thumb card-loader card-loader--tabs'></div>;
  }

  render() {
    if (!this.props.pics || this.props.pics.length === 0) {
      return this.renderPreloader();
    }

    let pic;

    if (this.props.pics) {
      pic = this.props.pics[this.state.index];
    }

    return (
      <div className='card__thumb-slider-item'>
        {this.renderArrows()}
        <img src={this.props.for_waters ? (this.props.no_pics ? this.props.pics : pic?.normal_photo) : pic}
             alt={this.props.filter_alt_img}
             className={`card__thumb-img ${this.props.pale_img ? 'img-pale' : ''}`}
        >
        </img>
      </div>
    );
  }
}
